export const ALL_ADMINS_REQUEST = 'ALL_ADMINS_REQUEST'
export const ALL_ADMINS_SUCCESS = 'ALL_ADMINS_SUCCESS'
export const ALL_ADMINS_FAIL = 'ALL_ADMINS_FAIL'

export const CREATE_ADMIN_REQUEST = 'CREATE_ADMIN_REQUEST'
export const CREATE_ADMIN_SUCCESS = 'CREATE_ADMIN_SUCCESS'
export const CREATE_ADMIN_RESET = 'CREATE_ADMIN_RESET'
export const CREATE_ADMIN_FAIL = 'CREATE_ADMIN_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'